export default [
	{
		path: '/my/account',
		name: 'MyAccount',
		component: () => import('@/views/my/account.vue'),
		meta: { title: '账号信息' }
	},
	{
		path: '/my/department/:id',
		name: 'MyDepartment',
		component: () => import('@/views/my/department.vue'),
		meta: { title: '我的医生团队' }
	}
]
